import { getWindow } from './general';
/**
 * Funtion is made to return boolean value based on policy doc
 * and user creds.
 */
export var isUserAllowedToViewAllPurchases = function (role, type) {
    var _a, _b, _c;
    var shouldRender = true;
    if (type === 'b2b') {
        var getPDocID = (_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.THD_CUST_ACCOUNT_OM) === null || _b === void 0 ? void 0 : _b.pdocid) !== null && _c !== void 0 ? _c : '';
        var rules = getPDocID
            ? JSON.parse(Buffer.from(getPDocID, 'base64').toString())
            : [];
        rules.forEach(function (rule) {
            if (rule.actions.includes('view') &&
                rule.resources[0] === 'order' &&
                rule.filters) {
                shouldRender = !rule.filters.find(function (_a) {
                    var _b, _c;
                    var name = _a.name, filterCandidate = _a.filterCandidate;
                    return name === 'purchaserPHFilter' &&
                        ((_b = filterCandidate === null || filterCandidate === void 0 ? void 0 : filterCandidate.user) === null || _b === void 0 ? void 0 : _b.role) === role.toUpperCase() &&
                        ((_c = filterCandidate === null || filterCandidate === void 0 ? void 0 : filterCandidate.user) === null || _c === void 0 ? void 0 : _c.type) === type.toUpperCase();
                });
            }
        });
    }
    return shouldRender;
};
